import React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

interface IImageBlockGridProps {
  headline: string
  subHeadline: string
  blockGrid: Array<{
    headline: string
    subHeadline: string
    link: {
      target: string
      title: string
      url: string
    }
    image: any
  }>
}

export const ImageBlockGrid = ({
  headline,
  subHeadline,
  blockGrid,
}: IImageBlockGridProps) => {
  return (
    blockGrid && (
      <div className="mx-auto mb-[75px] max-w-7xl border-b-2 px-[10px] pt-[60px] pb-[75px]">
        {headline && (
          <h2 className="mx-auto text-center text-darkBlue ">{headline}</h2>
        )}
        {subHeadline && (
          <p className="mx-auto mt-[11px] max-w-[500px] text-center font-semibold text-mediumGrey">
            {subHeadline}
          </p>
        )}
        {blockGrid && blockGrid?.length > 0 && (
          <div className="mt-[45px] flex flex-row flex-wrap items-center justify-center">
            {blockGrid.map((item, index) => {
              const gatsbyImage =
                item?.image && getImage(item?.image?.gatsbyImage)

              return (
                <Link
                  className="mx-[10px] mb-[20px] max-w-[295px]  cursor-pointer px-[8px] lg:mb-[36px] "
                  key={index}
                  to={item?.link?.url || "#"}
                >
                  <div
                    className={
                      item?.headline
                        ? "relative flex h-[274px] min-w-[295px] flex-col justify-end rounded-b-[4px] bg-gray-100  shadow-[0_3px_13px_0px_rgba(0,0,0,0.16)] duration-300 ease-in hover:shadow-[0_10px_23px_10px_rgba(0,0,0,0.16)]"
                        : "relative flex h-[274px] min-w-[295px]  flex-col  justify-center rounded-b-[4px] bg-gray-100  shadow-[0_3px_13px_0px_rgba(0,0,0,0.16)] duration-300 ease-in hover:shadow-[0_10px_23px_10px_rgba(0,0,0,0.16)]"
                    }
                  >
                    {gatsbyImage && (
                      <GatsbyImage
                        key={index}
                        image={gatsbyImage}
                        alt={item?.image?.altText || ""}
                        className="rounded-t-[4px]"
                      />
                    )}

                    {item?.headline && (
                      <div className="min-h-[70px] rounded-b-[4px] bg-[#FFF] px-[19px] pt-[13px] pb-[16px]">
                        <h4 className="font-neusa text-[24px] font-medium text-darkBlue">
                          {item?.headline}
                        </h4>
                        {item?.subHeadline && (
                          <div className="text-[13px] font-black leading-[16px] text-darkGrey">
                            {item?.subHeadline}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </Link>
              )
            })}
          </div>
        )}
      </div>
    )
  )
}

export default ImageBlockGrid
export const fragment = graphql`
  fragment ImageBlockGrid on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_ImageBlockGrid {
      fieldGroupName
      headline
      subHeadline
      blockGrid {
        headline
        subHeadline
        link {
          target
          title
          url
        }
        image {
          gatsbyImage(
            quality: 90
            width: 295
            height: 204
            fit: OUTSIDE
            formats: [AUTO, WEBP]
          )
        }
      }
    }
  }
`
